import { mapState } from 'vuex'

export default {
  data() {
    return {
      isValid: true,
      validityWhenGoingOffline: true
    }
  },
  computed: {
    ...mapState({
      offline: 'offline'
    })
  },
  watch: {
    offline(offline) {
      if (offline) {
        this.isValid = false
      } else {
        this.isValid = this.validityWhenGoingOffline
      }
    }
  },
  methods: {
    __setValidity(validity) {
      this.isValid = validity
      this.validityWhenGoingOffline = validity
      this.$emit('subview-event', { type: validity ? 'flow-step-valid' : 'flow-step-invalid' })
    }
  }
}
